import { FormLabel, Grid, TextField, Typography } from '@mui/material';
import PropTypes from 'prop-types';


const MetodologiasPreferidas = ({ promptData, setPromptData}) => {
    

    const handleMetodologiasPreferidas = (event) => {
        const { value } = event.target;
       
        setPromptData((prevData) => ({
            ...prevData,
            metodologias: value 
          }));
      };
    
    return (
        <Grid xs={12} lg={12} md={12}>
            <Typography id="modal-modal-title" sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color: '#336B87' }} >Metodologías preferidas</Typography>
            <FormLabel sx={{ fontFamily: 'montserrat', fontSize: '0.85rem' }}>Indica las estrategias o enfoques pedagógicos que deseas que se tengan en cuenta. Por ejemplo, metodologías activas, trabajo colaborativo, entre otras. </FormLabel>
            <TextField
                required
                id="contexto"
                placeholder='Escribe aquí las metodologías preferidas Ejemplo: trabajo colaborativo'
                name="contexto"
                fullWidth
                autoComplete="given-name"
                variant="outlined"
                value={promptData.metodologias}
                onChange={handleMetodologiasPreferidas}
                InputProps={{
                    sx: {
                        borderRadius:2,
                        mt:1,
                        mb: 3,
                        fontFamily: 'montserrat',
                        fontSize: '0.75rem',
                        color: '#005559',
                        '&::placeholder': {
                            color: '#005559',

                        },
                        '&:before': {
                            borderBottomColor: '#005559',

                        },
                        '&:after': {
                            borderBottomColor: '#005559',
                        },
                    }
                }}
            />
        </Grid>
    );
};

MetodologiasPreferidas.propTypes = {
  promptData: PropTypes.func.isRequired,
  setPromptData: PropTypes.func.isRequired,
};

export default MetodologiasPreferidas;




